export const labCases = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',
  NavSidebar: {},
  TabInit: {
    display: 'none',
    show: (() => {
      let d = false
      return (el, s) => {
        if (!d) {
          d = true
          Promise.resolve().then(() => s.root.update({ activeTab: 'lab' }))
        }
        return false
      }
    })()
  },

  MainContent: {
    flow: 'y',
    flex: '1',
    width: '100%',
    overflow: 'hidden',

    TopBar: {},
    ContentArea: {
      flow: 'x',
      gap: 'B',
      padding: 'B',
      flex: '1',
      height: '100%',
      width: '100%',

      PipelineSection: {
        flow: 'y',
        gap: 'A',
        flex: '1',
        height: '100%',
        width: '100%',
        overflowX: 'auto',

        PipelineTitle: {
          text: '{{ labCasePipeline | polyglot }}',
          fontSize: 'A',
          fontWeight: '700',
          color: 'inkText'
        },
        LabPipeline: {
          height: '100%',
          Submitted: {
            Cards: {
              children: [
                {
                  caseId: 'LAB-003',
                  patientName: 'Davit Gelashvili',
                  provider: 'Dr. Lomidze',
                  labVendor: 'TbilisiDent Lab',
                  type: 'Implant Abutment + Crown #19',
                  shade: 'A3',
                  dateSubmitted: 'Mar 12, 2026',
                  dateExpected: 'Mar 26, 2026',
                  status: 'Impression Sent',
                  notes: 'Digital scan uploaded'
                },
                {
                  caseId: 'LAB-006',
                  patientName: 'Luka Mchedlishvili',
                  provider: 'Dr. Kvaratskhelia',
                  labVendor: 'Caucasus Dental Lab',
                  type: 'Veneer #8, #9',
                  shade: 'BL1',
                  dateSubmitted: 'Mar 15, 2026',
                  dateExpected: 'Mar 29, 2026',
                  status: 'Impression Sent',
                  notes: 'Minimal prep, ultra-thin'
                },
                {
                  caseId: 'LAB-008',
                  patientName: 'Irakli Diasamidze',
                  provider: 'Dr. Beridze',
                  labVendor: 'TbilisiDent Lab',
                  type: 'E.max Inlay #30',
                  shade: 'A1',
                  dateSubmitted: 'Mar 16, 2026',
                  dateExpected: 'Mar 24, 2026',
                  status: 'Impression Sent',
                  notes: 'Conservative preparation'
                }
              ],
              childrenAs: 'state',
              childExtends: 'LabCaseCard'
            }
          },
          Fabrication: {
            Cards: {
              children: [
                {
                  caseId: 'LAB-001',
                  patientName: 'Giorgi Beridze',
                  provider: 'Dr. Lomidze',
                  labVendor: 'TbilisiDent Lab',
                  type: 'PFM Crown #14',
                  shade: 'A2',
                  dateSubmitted: 'Mar 10, 2026',
                  dateExpected: 'Mar 20, 2026',
                  status: 'In Fabrication',
                  notes: 'Custom staining requested'
                },
                {
                  caseId: 'LAB-004',
                  patientName: 'Mariam Tsiklauri',
                  provider: 'Dr. Beridze',
                  labVendor: 'Euro Dental Georgia',
                  type: 'Night Guard (upper)',
                  shade: '',
                  dateSubmitted: 'Mar 14, 2026',
                  dateExpected: 'Mar 21, 2026',
                  status: 'In Fabrication',
                  notes: 'Hard/soft combo, 2mm thickness'
                }
              ],
              childrenAs: 'state',
              childExtends: 'LabCaseCard'
            }
          },
          Quality: {
            Cards: {
              children: [
                {
                  caseId: 'LAB-005',
                  patientName: 'Ana Javakhishvili',
                  provider: 'Dr. Lomidze',
                  labVendor: 'TbilisiDent Lab',
                  type: '3-unit Bridge #3-5',
                  shade: 'A2',
                  dateSubmitted: 'Mar 5, 2026',
                  dateExpected: 'Mar 19, 2026',
                  status: 'Quality Check',
                  notes: 'Full contour zirconia'
                }
              ],
              childrenAs: 'state',
              childExtends: 'LabCaseCard'
            }
          },
          TryIn: {
            Cards: {
              children: [
                {
                  caseId: 'LAB-007',
                  patientName: 'Tamara Lomidze',
                  provider: 'Dr. Lomidze',
                  labVendor: 'Euro Dental Georgia',
                  type: 'Partial Denture (lower)',
                  shade: 'A3',
                  dateSubmitted: 'Mar 1, 2026',
                  dateExpected: 'Mar 22, 2026',
                  status: 'Try-in Scheduled',
                  notes: 'Cast metal framework'
                }
              ],
              childrenAs: 'state',
              childExtends: 'LabCaseCard'
            }
          },
          Ready: {
            Cards: {
              children: [
                {
                  caseId: 'LAB-002',
                  patientName: 'Nino Kapanadze',
                  provider: 'Dr. Kvaratskhelia',
                  labVendor: 'Caucasus Dental Lab',
                  type: 'Zirconia Crown #8',
                  shade: 'BL2',
                  dateSubmitted: 'Mar 8, 2026',
                  dateExpected: 'Mar 18, 2026',
                  status: 'Ready for Pickup',
                  notes: 'Patient prefers high translucency'
                }
              ],
              childrenAs: 'state',
              childExtends: 'LabCaseCard'
            }
          }
        }
      },

      VendorPanel: {
        flow: 'y',
        gap: 'A',
        width: '280px',
        minWidth: '280px',
        background: 'inkSurface',
        round: 'A',
        padding: 'A',

        VendorTitle: {
          text: '{{ labVendors2 | polyglot }}',
          fontSize: 'Z',
          fontWeight: '700',
          color: 'inkText',
          marginBottom: 'Z'
        },

        Vendor1: {
          flow: 'y',
          gap: 'X',
          padding: 'Z',
          borderBottom: '1px solid inkBorder',
          VendorName1: {
            text: '{{ tbilisidentLab | polyglot }}',
            fontSize: 'Z',
            fontWeight: '600',
            color: 'inkText'
          },
          VendorInfo1: {
            flow: 'x',
            gap: 'Z',
            flexWrap: 'wrap',
            Turnaround1: {
              text: '{{ turnaround710Days | polyglot }}',
              fontSize: 'Y',
              color: 'inkMuted'
            },
            Rating1: {
              text: '{{ rating485 | polyglot }}',
              fontSize: 'Y',
              color: 'gold'
            },
            ActiveCases1: {
              text: '{{ activeCases4 | polyglot }}',
              fontSize: 'Y',
              color: 'teal'
            }
          }
        },

        Vendor2: {
          flow: 'y',
          gap: 'X',
          padding: 'Z',
          borderBottom: '1px solid inkBorder',
          VendorName2: {
            text: '{{ caucasusDentalLab | polyglot }}',
            fontSize: 'Z',
            fontWeight: '600',
            color: 'inkText'
          },
          VendorInfo2: {
            flow: 'x',
            gap: 'Z',
            flexWrap: 'wrap',
            Turnaround2: {
              text: '{{ turnaround57Days | polyglot }}',
              fontSize: 'Y',
              color: 'inkMuted'
            },
            Rating2: {
              text: '{{ rating465 | polyglot }}',
              fontSize: 'Y',
              color: 'gold'
            },
            ActiveCases2: {
              text: '{{ activeCases2 | polyglot }}',
              fontSize: 'Y',
              color: 'teal'
            }
          }
        },

        Vendor3: {
          flow: 'y',
          gap: 'X',
          padding: 'Z',
          VendorName3: {
            text: '{{ euroDentalGeorgia | polyglot }}',
            fontSize: 'Z',
            fontWeight: '600',
            color: 'inkText'
          },
          VendorInfo3: {
            flow: 'x',
            gap: 'Z',
            flexWrap: 'wrap',
            Turnaround3: {
              text: '{{ turnaround1014Days | polyglot }}',
              fontSize: 'Y',
              color: 'inkMuted'
            },
            Rating3: {
              text: '{{ rating445 | polyglot }}',
              fontSize: 'Y',
              color: 'gold'
            },
            ActiveCases3: {
              text: '{{ activeCases2 | polyglot }}',
              fontSize: 'Y',
              color: 'teal'
            }
          }
        }
      }
    }
  }
}
